<template>
  <div>
    <v-app-bar
      dense
      flat
      height="50"
    >
      <v-row align="center">
        <v-col
          xs="12"
          sm="5"
          md="4"
          class="d-none d-sm-flex"
        >
          <search-field
            :search-text.sync="searchText"
            :status="status"
            @statusChange="changeStatus"
            @search="onSearch"
          />
        </v-col>
        <v-col
          xs="12"
          sm="7"
          md="8"
          align="end"
        >
          <v-btn
            id="menu_item_refresh"
            color="primary"
            :loading="loader"
            class="mr-2 elevation-0"
            @click.native="reload()"
          >
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
          <register
            :show-dialog.sync="register"
            :is-edit="!!selectedTenant"
            :selected-tenant="selectedTenant"
            @refresh="reload"
          />
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                id="account_add"
                slot="activator"
                :disabled="!$store.getters.checkUserPrivilege('tenant')"
                class="elevation-0"
                color="success"
                @click="newTenant()"
                v-on="on"
              >
                <v-icon>mdi-plus</v-icon> inventory Tenant
              </v-btn>
            </template>
            <span>Register a new inventory tenant.</span>
          </v-tooltip>
        </v-col>
      </v-row>
    </v-app-bar>
    <v-card
      flat
      outlined
      tile
    >
      <v-card-text>
        <v-row>
          <v-col
            xs="12"
            class="d-flex d-sm-none"
          >
            <search-field
              :search-text.sync="searchText"
              :status="status"
              @statusChange="changeStatus"
              @search="onSearch"
            />
          </v-col>
        </v-row>
        <!-- <v-row>
          <v-divider></v-divider>
        </v-row> -->
        <v-row>
          <v-col
            xs="12"
            class="pa-0"
          >
            <v-data-table
              :headers="headers"
              :items="tenantList"
              :items-per-page="limit"
              :loading="loader"
              mobile-breakpoint="0"
            >
              <template v-slot:[`item.id`]="{ item }">
                <v-icon x-small>
                  mdi-pound
                </v-icon>
                {{ item.id }}
              </template>
              <template v-slot:[`item.account`]="{ item }">
                <v-chip
                  v-show="item.account"
                  label
                  @click="openAssignedAccounts(item)"
                >
                  {{ item.account }}
                </v-chip>
                <v-btn
                  color="primary"
                  icon
                  small
                  @click="assignAccount(item.id)"
                >
                  <v-icon small>
                    mdi-plus
                  </v-icon>
                </v-btn>
              </template>
              <template v-slot:[`item.activeStatus`]="{ item }">
                <v-chip
                  label
                  :color="item.activeStatus ? 'success' : 'error'"
                >
                  {{ item.activeStatus ? "Active" : "In-active" }}
                </v-chip>
              </template>
              <template v-slot:[`item.options`]="{ item }">
                <tenant-options
                  :tenant="item"
                  @edit="edit"
                  @reload="getTenants"
                />
              </template>
            </v-data-table>

            <link-account
              ref="linkAccount"
              @reload="getTenants"
            />
          </v-col>
        </v-row>
      </v-card-text>
      <!-- <v-card-actions v-show="totalPages > 1">
        <v-row>
          <v-col>
            <v-pagination 
              v-model="page" 
              :length="totalPages"
            />
          </v-col>
        </v-row>
      </v-card-actions> -->
    </v-card>
  </div>
</template>

<script>
import { failure } from "@/mixins/common";
import Register from "./Register";
import TenantOptions from "./TenantOptions";
import SearchField from "@/components/utils/SearchField";
import LinkAccount from "./LinkAccount.vue";

export default {
  components: {
    Register,
    TenantOptions,
    SearchField,
    LinkAccount
  },
  mixins: [failure],
  data() {
    return {
      loader: false,
      headers: [
        { text: "Id", value: "id", align: "start", sortable: false },
        { text: "Name", value: "name", align: "start", sortable: true },
        {
          text: "Accounts",
          value: "account",
          align: "center",
          sortable: false
        },
        {
          text: "Status",
          value: "activeStatus",
          align: "center",
          sortable: false
        },
        { text: "", value: "options", align: "end", sortable: false }
      ],
      limit: 10,
      page: 1,
      tenants: [],
      searchText: null,
      register: false,
      status: "",
      selectedTenant: null
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.tenants.length / this.limit);
    },
    tenantList() {
      if (!this.searchText) return this.tenants;

      const search = this.searchText.toLowerCase();
      return this.tenants.filter(
        (tenant) => tenant.name?.toLowerCase().includes(search)
      );
    }
  },
  created() {
    this.init();
  },
  methods: {
    getTenants() {
      this.loader = true;
      let url = `${this.ADMIN_API_URL}/inventory/tenants?status=${this.status}`;
      this.$http.get(url).then(
        (res) => {
          this.tenants = res.body || [];
          this.loader = false;
        },
        (failure) => {
          this.handleFailure(failure);
        }
      );
    },
    search() {
      this.page = 1;
      this.getTenants();
    },
    reload() {
      this.searchText = null;
      this.status = "";
      this.selectedTenant = null;
      this.search();
    },
    onSearch(val) {
      console.log({ val }, "ON SEARCH");
      if (!val || val.length >= 3) {
        this.searchText = val;
      }
    },
    changeStatus(status) {
      this.status = status;
      this.search();
    },
    newTenant() {
      this.register = true;
    },

    init() {
      this.$store.commit("setTitle", "tenant");
      this.getTenants();
    },
    clear() {
      this.errors = {};
      this.$refs.form.reset();
    },
    assignAccount(id) {
      this.$refs.linkAccount.open(id);
    },
    openAssignedAccounts(tenant) {
      this.$refs.linkAccount.openAssignedAccounts(tenant.id, tenant.accounts);
    },
    edit(item) {
      this.selectedTenant = item;
      this.register = true;
    }
  }
};
</script>
